export default __webpack_public_path__ + "static/media/crown.acf5ea5c.mov";